import type { SdCardEntry } from './types';

// `webkitRelativePath` carries the picked folder as its first segment; detection
// and packing match on path content (day folders, marker basenames), so that
// prefix is harmless and left as-is.
export const readSelectedDirectory = (files: File[]): SdCardEntry[] =>
  files.map((file) => ({
    path: (file.webkitRelativePath || file.name).replace(/\\/g, '/'),
    file,
  }));

export const basename = (path: string): string => {
  const normalized = path.replace(/\\/g, '/');
  const idx = normalized.lastIndexOf('/');
  return idx >= 0 ? normalized.slice(idx + 1) : normalized;
};

export const findByBasename = (
  entries: SdCardEntry[],
  name: string,
): SdCardEntry | undefined =>
  entries.find((entry) => basename(entry.path).toLowerCase() === name.toLowerCase());

/**
 * The `importInfo.txt` pTS writes into every container. SignalViewer ignores it,
 * but keeping it makes the archive a faithful reproduction of a pTS export.
 */
export const buildImportInfo = (generationLabel: string): string =>
  [
    'Imported by Signal Viewer Web',
    `Import date: ${new Date().toISOString()}`,
    'Import type: SdCard',
    `Generation: ${generationLabel}`,
    '',
  ].join('\n');
